import { DatePickerExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
export const DatePickerTypeConfig = [
  {
    text: 'Date field',
    subText: '',
    value: DatePickerExtension.DeliveryDatePickerType.DATE_FIELD,
    defaultChecked: true,
    checked: (val: string) => {
      return val === DatePickerExtension.DeliveryDatePickerType.DATE_FIELD;
    },
  },
  {
    text: 'Calendar',
    subText: '',
    value: DatePickerExtension.DeliveryDatePickerType.CALENDAR,
    defaultChecked: false,
    checked: (val: string) => {
      return val === DatePickerExtension.DeliveryDatePickerType.CALENDAR;
    },
  },
];
